import { BulkPhotoUpload, type BulkPhotoConfig, type PhotoOutcome } from '../components/BulkPhotoUpload';

/**
 * A photographer's folder of student photographs.
 *
 * ⚠ THE SCREEN NOW LIVES IN components/BulkPhotoUpload, because staff photographs work identically
 * and every detail on it — the caps, the outcome table, the distinction between a failure and a
 * note — was learned once. This file is the wording specific to children.
 */
interface StudentPhotoOutcome extends PhotoOutcome {
  admissionNumber: string | null;
}

const config: BulkPhotoConfig<StudentPhotoOutcome> = {
  eyebrow: 'Students',
  title: 'Upload photographs',
  intro: (
    <>
      A whole folder at once. Name each photograph with the student's admission number —
      <strong> A-100.jpg</strong>, <strong>A-101.jpg</strong> — then zip the folder and upload it
      here. Sub-folders are fine.
    </>
  ),
  uploadPath: '/api/students/photos/bulk',
  smallPrint: (
    <>
      JPEG or PNG, up to 5 MB each and 50 MB for the zip. A family who has withdrawn photograph
      consent is skipped and named in the report.
    </>
  ),
  keyLabel: 'Admission no.',
  keyOf: (o) => o.admissionNumber,
  allMatched: 'Every file matched a student and was saved.',
};

export function StudentPhotosPage() {
  return <BulkPhotoUpload config={config} />;
}
